/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MapInteractionsService } from '@map/services/mapInteractions.service';
import { Actions } from '@ngxs/store';
import { CreateBufferCommand } from './create-buffer.command';

export function createBufferFactory() {
    const command = new CreateBufferCommand();
    command.setDependencies({
        matDialog: inject(MatDialog),
        snackBar: inject(MatSnackBar),
        interactions: inject(MapInteractionsService),
        actions$: inject(Actions)
    });
    return command;
}
